/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionconfirmone2Inputs */

const en_actionconfirmone2 = /** @type {(inputs: Actionconfirmone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It goes to one favourite. One action per day.`)
};

const de_actionconfirmone2 = /** @type {(inputs: Actionconfirmone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie geht an einen Favoriten. Pro Tag geht eine Aktion.`)
};

/**
* | output |
* | --- |
* | "It goes to one favourite. One action per day." |
*
* @param {Actionconfirmone2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionconfirmone2 = /** @type {((inputs?: Actionconfirmone2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionconfirmone2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionconfirmone2(inputs)
	return de_actionconfirmone2(inputs)
});
export { actionconfirmone2 as "actionConfirmOne" }